<template>
  <div class="w-full" :class="flat ? '' : ['bg-white', 'rounded-lg', 'border', 'overflow-hidden', cardShadowClasses]">
    <slot v-if="!isLoading" />
    <BasicSpinner v-else color="gray-400" class="my-8 flex justify-center" />
  </div>
</template>
<script>
import BasicSpinner from '@/components/Molecules/BasicSpinner'
import { defineComponent } from 'vue'
import { cardShadowClasses } from '@/config'

export default defineComponent({
  components: {
    BasicSpinner
  },
  data() {
    return { cardShadowClasses }
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
</script>
